import { render, staticRenderFns } from "./BillingPaymentsPage.vue?vue&type=template&id=394752ac&scoped=true&"
import script from "./BillingPaymentsPage.vue?vue&type=script&lang=js&"
export * from "./BillingPaymentsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394752ac",
  null
  
)

export default component.exports